const movieEmojis = new Map([  
	['Godfather', '🇮🇹🔫🐴'],
  ['Star Wars', '⭐⚔️🤖'],
  ['Jurassic Park', '🦖🌴🚁'],
  ['Shawshank Redemption', '👮‍♂️🏛️🗝️'],
  ['Forrest Gump', '🏃‍♂️🍫🏓'],
  ['Lord of the Rings', '💍🏔️🧙‍♂️'],
  ['Titanic', '🚢❤️🚣‍♀️'],
  ['Matrix', '🔴💊💻'],
  ['Avengers', '🛡️🔨🕷️'],
  ['Interstellar', '🚀🌾⏳'],
  ['Pulp Fiction', '🍔🔫💼'],
  ['Silence of the Lambs', '🦋🍷🔍'],
  ['Fight Club', '👊🧼🤫'],
  ['Goodfellas', '🔫💰🍸'],
  ['Dark Knight', '🦇💥🃏'],
  ['Lion King', '🦁👑🌄'],
  ['Saving Private Ryan', '🎖️🏖️💥'],
  ['The Terminator', '🤖🕶️🔫'],
  ['Back to the Future', '🚗⚡🕰️'],
  ['Indiana Jones', '👨‍🎓🏺🐍'],
  ['Gladiator', '⚔️🏟️👑'],
  ['Jaws', '🦈🏊‍♂️⛵'],
  ['Die Hard', '🎄💥🔫'],
  ['The Exorcist', '😱👧🙏'],
  ['Blade Runner', '🤖🔍🌆'],
  ['Alien', '👽🚀🔧'],
  ['Sixth Sense', '👦👻💬'],
  ['Green Mile', '⛓️🐭⚡'],
  ['Prestige', '🎩🐦⚡'],
  ['A Clockwork Orange', '🥛🔨🎭'],
  ['Shining', '🔪🚪❄️'],
  ['Departed', '🔫🐭📱']
]);

export default movieEmojis;
